import { createTheme, ThemeOptions } from "@mui/material/styles";

// Environment-based primary color
// Dev (supernews-273a7): Brown/Orange
// Prod (supernews-prod): Purple
const isDev = process.env.REACT_APP_FIREBASE_PROJECT_ID === "supernews-273a7";
const primaryColor = isDev ? "#853d10" : "#6d00a3";

const themeOptions: ThemeOptions = {
  palette: {
    primary: {
      main: primaryColor,
    },
    secondary: {
      main: "#2a9857",
    },
    background: {
      default: "#f5f5f5",
      paper: "#fffffa",
    },
  },
  typography: {
    fontFamily: [
      'Hind',
      '-apple-system',
      'BlinkMacSystemFont',
      'system-ui',
      'sans-serif',
    ].join(','),
    h1: {
      fontFamily: [
        'Hind',
        '-apple-system',
        'BlinkMacSystemFont',
        'system-ui',
        'sans-serif',
      ].join(','),
      fontWeight: 700,
    },
    h2: {
      fontFamily: [
        'Hind',
        '-apple-system',
        'BlinkMacSystemFont',
        'system-ui',
        'sans-serif',
      ].join(','),
      fontWeight: 700,
    },
    h3: {
      fontFamily: [
        'Hind',
        '-apple-system',
        'BlinkMacSystemFont',
        'system-ui',
        'sans-serif',
      ].join(','),
      fontWeight: 700,
    },
    h4: {
      fontFamily: [
        'Hind',
        '-apple-system',
        'BlinkMacSystemFont',
        'system-ui',
        'sans-serif',
      ].join(','),
      fontWeight: 600,
    },
    h5: {
      fontFamily: [
        'Hind',
        '-apple-system',
        'BlinkMacSystemFont',
        'system-ui',
        'sans-serif',
      ].join(','),
      fontWeight: 600,
    },
    h6: {
      fontFamily: [
        'Hind',
        '-apple-system',
        'BlinkMacSystemFont',
        'system-ui',
        'sans-serif',
      ].join(','),
      fontWeight: 600,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          overflowX: "hidden",
          maxWidth: "100vw",
        },
        body: {
          backgroundColor: "#fffffa",
          overflowX: "hidden",
          maxWidth: "100vw",
          position: "relative",
        },
        "*": {
          boxSizing: "border-box",
          userSelect: "none",
          WebkitUserSelect: "none",
          MozUserSelect: "none",
          msUserSelect: "none",
        },
        // Allow text selection for input fields and buttons
        "input, textarea, button, [role='button'], [role='textbox']": {
          userSelect: "text",
          WebkitUserSelect: "text",
          MozUserSelect: "text",
          msUserSelect: "text",
        },
        // Ensure all containers respect viewport width
        ".MuiContainer-root": {
          maxWidth: "100%",
          paddingLeft: "16px",
          paddingRight: "16px",
        },
        // Make images responsive by default
        "img": {
          maxWidth: "100%",
          height: "auto",
        },
        // Prevent tables from causing horizontal scroll
        "table": {
          maxWidth: "100%",
          overflowX: "auto",
          display: "block",
        },
      },
    },
  },
};

const theme = createTheme(themeOptions);

export default theme;

